import { Component, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-norolepage',
  templateUrl: './norolepage.component.html',
  styleUrls: ['./norolepage.component.css']
})
export class NorolepageComponent implements OnInit {

  constructor() { }
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
      return true;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/norolepage/norolepage.component.ts